// extracted by mini-css-extract-plugin
export default {"dropdown_div":"RegionDropDawn_dropdown_div__H7Jte","dropdown":"RegionDropDawn_dropdown__5PBfX"};